import type { BadgeVariant } from 'shared/atoms/Badge/Badge'
import type { BookingStatusType } from '../molecules/BookingStatus/BookingStatus'

export type BookingDisplayStatus =
	| 'scheduled'
	| 'awaitingArrival'
	| 'active'
	| 'expired'
	| 'overdue'
	| 'noShow'
	| 'completed'
	| 'cancelled'
	| 'abandoned'

export const BOOKING_DISPLAY_VARIANTS: Record<BookingDisplayStatus, BadgeVariant> = {
	scheduled: 'primary',
	awaitingArrival: 'warning',
	active: 'success',
	expired: 'muted',
	overdue: 'danger',
	noShow: 'warning',
	completed: 'muted',
	cancelled: 'danger',
	abandoned: 'muted'
}

const startOfToday = () => {
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	return today
}

const isPastEndDate = (endDate: string) => {
	const end = new Date(endDate)
	end.setHours(0, 0, 0, 0)

	return end < startOfToday()
}

export const getBookingDisplayStatus = (
	status: BookingStatusType,
	startDate: string,
	endDate: string
): BookingDisplayStatus => {
	switch (status) {
		case 'RESERVED':
		case 'CONFIRMED':
			if (isPastEndDate(endDate)) return 'expired'

			return new Date(startDate) > startOfToday() ? 'scheduled' : 'awaitingArrival'
		case 'ARRIVED':
			return isPastEndDate(endDate) ? 'expired' : 'active'
		case 'OVERDUE':
			return 'overdue'
		case 'NO_SHOW':
			return 'noShow'
		case 'CANCELLED':
			return 'cancelled'
		case 'ABANDONED':
			return 'abandoned'
		case 'COMPLETED':
		default:
			return 'completed'
	}
}

export const hasBookingStarted = (displayStatus: BookingDisplayStatus) =>
	displayStatus !== 'scheduled' && displayStatus !== 'awaitingArrival'
